import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { List, ListStatus } from 'dashboard/models/list';
import { User } from 'dashboard/models/user';
import Action from 'lib/interfaces/Action';
import { Iso8601DateString } from 'lib/types';

export interface ListsFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  status?: ListStatus[];
}

export type ListsActions =
  | Action<ListsActionType.SetLists, SetListsPayload>
  | Action<ListsActionType.SetList, SetListPayload>
  | Action<ListsActionType.SetListsDetails, SetListsDetailsPayload>
  | Action<ListsActionType.SetListsSortParams, SetListsSortParamsPayload>
  | Action<ListsActionType.SetListsFilters, SetListsFiltersPayload>;

export enum ListsActionType {
  SetLists = 'lists/SET_LISTS',
  SetList = 'lists/SET_LIST',
  SetListsDetails = 'lists/SET_LISTS_DETAILS',
  SetListsSortParams = 'lists/SET_LISTS_SORT_PARAMS',
  SetListsFilters = 'lists/SET_LISTS_FILTERS',
}

interface SetListsPayload {
  lists: List[];
}

export function setLists(lists: List[]): Action<ListsActionType.SetLists, SetListsPayload> {
  return {
    payload: {
      lists,
    },
    type: ListsActionType.SetLists,
  };
}

interface SetListPayload {
  list: List;
  user: User;
}

export function setList(list: List, user: User): Action<ListsActionType.SetList, SetListPayload> {
  return {
    payload: {
      list,
      user,
    },
    type: ListsActionType.SetList,
  };
}

interface SetListsDetailsPayload {
  users: User[];
}

export function setListsDetails(
  users: User[],
): Action<ListsActionType.SetListsDetails, SetListsDetailsPayload> {
  return {
    payload: {
      users,
    },
    type: ListsActionType.SetListsDetails,
  };
}

interface SetListsSortParamsPayload {
  sortParams: SortParams;
}

export function setListsSortParams(
  sortParams: SortParams,
): Action<ListsActionType.SetListsSortParams, SetListsSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: ListsActionType.SetListsSortParams,
  };
}

interface SetListsFiltersPayload {
  filters: ListsFilterParams;
}

export function setListsFilters(
  filters: ListsFilterParams,
): Action<ListsActionType.SetListsFilters, SetListsFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: ListsActionType.SetListsFilters,
  };
}
